
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { FormModal, SuccessIcon, FormSubmit, Preloader } from "../components";

type ConfigKeys = "header" | "text1" | "text2" | "text3" | "download";

@Component({
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    AmSpacing,
    AmButton,
    FormModal,
    SuccessIcon,
    FormSubmit,
    Preloader
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: Record<ConfigKeys, string>;

  created() {
    if (this.config && this.config.download) {
      window.location.href = this.config.download;
    }
  }
}
